import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useDeleteLinkMutation, useLinkDetailsQuery } from 'api';
import { NewConfirmDialog, GoBackButtonWithTitle, PageWrapper, Spinner } from 'components';
import { useModal } from 'hooks';

import { EditQuickLinkForm } from '../../components';
import { ContentW, Wrapper } from './styled';

export function EditQuickLinkPage(): ReactElement {
  const { t } = useTranslation();
  const { linkId = '' } = useParams<string>();

  const { isLoading, link } = useLinkDetailsQuery(linkId);
  const { handleOpenModal, handleCloseModal, isOpen } = useModal();
  const { deleteLinkMutation } = useDeleteLinkMutation();

  async function handleDeleteTarget() {
    await deleteLinkMutation(linkId);
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <PageWrapper>
      <GoBackButtonWithTitle title={t('quickLinks.editLinkPageTitle')} />
      <Wrapper>
        {link && (
          <ContentW>
            <EditQuickLinkForm defaultValues={link} handleOpenModal={handleOpenModal} />
          </ContentW>
        )}
      </Wrapper>

      <NewConfirmDialog
        title={t('quickLinks.removeModal.title', { title: link?.title })}
        subTitle={t('quickLinks.removeModal.subtitle')}
        open={isOpen}
        onConfirm={handleDeleteTarget}
        onClose={handleCloseModal}
        submitLabel={t('quickLinks.removeModal.successButton')}
        cancelLabel={t('quickLinks.removeModal.cancelButton')}
      />
    </PageWrapper>
  );
}
